// extracted by mini-css-extract-plugin
export default {"image":"m2-z","loaded":"n2-z"};